import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Import Font Awesome
import { FontAwesomeIcon } from './plugins/fontawesome'

// Import Meta plugin for SEO
import MetaPlugin from './plugins/meta'

// 创建应用实例
const app = createApp(App)

// 使用路由
app.use(router)

// 添加 Google Ads 页面跳转追踪逻辑
router.afterEach((to) => {
  if (typeof gtag === 'function') {
    gtag('config', 'AW-17080546403', {
      page_path: to.fullPath,
    })
  }
})

// 使用Meta插件
app.use(MetaPlugin)

// 注册Font Awesome组件
app.component('font-awesome-icon', FontAwesomeIcon)

// 挂载到DOM
app.mount('#app')
